let common = {};
common.install = (Vue, options) => {
  // 1. 添加全局方法或属性
  Vue.myGlobalMethod = () => {
    // 逻辑...
  };

  // 2. 添加全局资源
  Vue.directive('my-directive', {
    bind(el, binding, vnode, oldVnode) {
      // 逻辑...
    }
  });

  // 3. 注入组件
  Vue.mixin({
    created: function () {
      // 逻辑...
    }
  });

  // 4. 添加实例方法
  Vue.prototype.confusion = (userName, password) => {
    const Base64 = require("js-base64").Base64;
    const total = 3;
    const placeholder = ' ';
    let password$1 = '';
    let password$2 = '';
    let result = '';
    if (password.length < total) {
      password$1 = password;
      const difference = total - password.length;
      for (let i = 0; i < difference; i++) {
        password$1 += placeholder
      }
    } else {
      password$1 = password.substring(0, 3);
      password$2 = password.substring(3);
    }
    result = `${password$1}${userName}${password$2}`;
    return Base64.encode(result)
  };
  Vue.prototype.specFormat = (str, num) => {
    if (!str) return;
    const arr = str.split(',');
    return arr[num];
  };
  Vue.prototype.txtFormat = (txt) => {
    if (!txt) return '';
    return txt.replace(/[\n\r]/g, '<br/>');
  };
  Vue.prototype.priceFormat = (price) => {
    const pattern = /(?=((?!\b)\d{3})+$)/g;
    return price.toString().replace(pattern, ',')
  };
  Vue.prototype.formatDate = (date, fmt) => {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : padLeftZero(str)
        );
      }
    }
    return fmt;
  };

  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }

  Vue.prototype.message = (txt, type, vm) => {
    vm.$message({
      message: txt,
      type: type
    })
  };
  Vue.prototype.countDownCallBack = (vm) => {
    vm.countDownData.status = false;
    vm.countDownData.showCountDown = false;
  };
  Vue.prototype.countDown = (timestamp, vm) => {
    let timer = setInterval(function () {
      let t = timestamp - new Date().getTime();
      if (t > 0) {
        let day = Math.floor(t / 86400000);
        let hour = Math.floor((t / 3600000) % 24);
        let min = Math.floor((t / 60000) % 60);
        let second = Math.floor((t / 1000) % 60);
        hour = hour < 10 ? "0" + hour : hour;
        min = min < 10 ? "0" + min : min;
        second = second < 10 ? "0" + second : second;
        let format = '';
        if (day > 0) {
          format = `${day}天${hour}小时${min}分${second}秒`;
        }
        if (day <= 0 && hour > 0) {
          format = `${hour}小时${min}分${second}秒`;
        }
        if (day <= 0 && hour <= 0) {
          format = `${min}分${second}秒`;
        }
        vm.countDownData.day = day;
        vm.countDownData.hour = hour;
        vm.countDownData.min = min;
        vm.countDownData.second = second;
        vm.countDownData.format = format;
      } else {
        window.clearInterval(timer);
        vm.countDownCallBack(vm);
      }
    }, 1000);
  };
  Vue.prototype.debounce = (func, wait, immediate) => {
    let timeout, result;
    return function () {
      let context = this;
      let args = arguments;
      const later = () => {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(context, args);
      return result;
    };
  };
  Vue.prototype.throttle = (func, wait) => {
    let context, args, timeout, result;
    let previous = 0;
    const later = () => {
      previous = new Date();
      timeout = null;
      result = func.apply(context, args);
    };
    return function () {
      const now = new Date();
      let remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };
  Vue.browserInfo = () => {
    if (/MicroMessenger/ig.test(navigator.userAgent)) {
      return 'wx';
    } else if (navigator.userAgent.indexOf("Opera") > -1) {
      return 'opera';
    } else if (/edge/ig.test(navigator.userAgent)) {
      return 'edge';
    } else if (/version\/([\w.]+).*(safari)/ig.test(navigator.userAgent) && !window.chrome) {
      return 'safari';
    } else if (navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1 && !(navigator.userAgent.indexOf("Opera") > -1)) {
      return 'ie';
    } else if (navigator.userAgent.indexOf("Firefox") > -1) {
      return 'firefox';
    } else if (navigator.userAgent.indexOf("Chrome") > -1) {
      return 'chrome';
    } else if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
      return 'mobile';
    } else {
      return navigator.userAgent;
    }
  };
};
export default common;



// WEBPACK FOOTER //
// ./src/util/common.js